<template>
  <el-dialog :title="action === 'addMerchant' ? $t('text.addMerchant') : $t('text.editMerchant')"
             :visible="show"
             @close="closeDialog"
             @open="openDialog"
             :close-on-click-modal="false">
    <el-form :model="form" :rules="rules" ref="form">
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('text.loginName')"
                        :label-width="formLabelWidth"
                        prop="loginName">
            <el-input v-model="form.loginName"
                      autocomplete="off"
                      :placeholder="$t('message.inputMerchantLoginName')"
                      :disabled="action === 'editMerchant'"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('text.merchantName')"
                        :label-width="formLabelWidth"
                        prop="merchantName">
            <el-input v-model="form.merchantName"
                      autocomplete="off"
                      :placeholder="$t('message.inputMerchantName')"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('text.bdName')"
                        :label-width="formLabelWidth"
                        prop="bdName">
            <el-input v-model="form.bdName"
                      autocomplete="off"
                      :placeholder="$t('message.inputBdName')"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item :label="$t('text.collectionStatus')"
                        :label-width="formLabelWidth"
                        prop="depositStatus">
            <el-select v-model="form.depositStatus" :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('collectionStatus.00')" value="00"></el-option>
              <el-option :label="$t('collectionStatus.01')" value="01"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('text.disbursementStatus')"
                        :label-width="formLabelWidth"
                        prop="withdrawStatus">
            <el-select v-model="form.withdrawStatus" :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('disbursementStatus.00')" value="00"></el-option>
              <el-option :label="$t('disbursementStatus.01')" value="01"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('text.productionStatus')"
                        :label-width="formLabelWidth"
                        prop="prodStatus">
            <el-select v-model="form.prodStatus"
                       :placeholder="$t('message.chooseOne')"
                       :disabled="form.prodStatus !== '01'">
              <el-option :label="$t('productionStatus.00')"
                         value="00"
                         :disabled="form.prodStatus === '01'"/>
              <el-option :label="$t('productionStatus.01')"
                         value="01"
                         :disabled="form.prodStatus === '01'"/>
              <el-option :label="$t('productionStatus.02')"
                         value="02"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item :label="$t('text.merchantType')"
                        :label-width="formLabelWidth"
                        prop="merchantType">
            <el-select v-model="form.merchantType" :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('merchantType.01')" value="01"></el-option>
              <el-option :label="$t('merchantType.00')" value="00"></el-option>
              <el-option :label="$t('merchantType.02')" value="02"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item v-if="ROLE_TYPE.isManager()"
                        :label="$t('text.settlementCycle')"
                        :label-width="formLabelWidth"
                        prop="settlementCycle">
            <el-select v-model="form.settlementCycle" :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('settlementCycle.D0')" value="D0"></el-option>
              <el-option :label="$t('settlementCycle.T1')" value="T1"></el-option>
              <el-option :label="$t('settlementCycle.D0T1')" value="D0T1"></el-option>
              <el-option :label="$t('settlementCycle.T2')" value="T2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('text.notifyV2')"
                        :label-width="formLabelWidth"
                        prop="notifyV2">
            <el-select v-model="form.notifyV2"
                       :placeholder="$t('message.chooseOne')"
                       :disabled="form.notifyV2 === '01'">
              <el-option :label="$t('notifyV2.01')"
                         value="01"
                         :disabled="form.notifyV2 === '01'"/>
              <el-option :label="$t('notifyV2.00')"
                         value="00"
                         :disabled="form.notifyV2 === '00'"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item :label="$t('text.creditFlag')"
                        :label-width="formLabelWidth"
                        prop="creditFlag">
            <el-select v-model="form.creditFlag" :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('creditFlag.00')" value="00"></el-option>
              <el-option :label="$t('creditFlag.01')" value="01"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('text.merchantRiskFlag')"
                        :label-width="formLabelWidth"
                        prop="riskFlag">
            <el-select v-model="form.riskFlag" :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('riskFlag.00')" value="00"></el-option>
              <el-option :label="$t('riskFlag.01')" value="01"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item v-if="form.creditFlag==='01'"
                        :label="$t('text.creditRate')"
                        :label-width="formLabelWidth"
                        prop="creditRate">
            <el-input v-model="form.creditRate"
                      @input="(val) => handleInput(val, 'creditRate')"
                      autocomplete="off"
                      :placeholder="$t('message.input')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item v-if="form.creditFlag==='01'"
                        :label="$t('text.creditQuota')"
                        :label-width="formLabelWidth"
                        prop="availableCreditQuota">
            <el-input v-model="form.availableCreditQuota" :placeholder="$t('message.inputQuotaAmount')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item :label="$t('text.forceCloseShowCheckoutCustomerInfoFlag')"
                        :label-width="formLabelWidth"
                        prop="forceCloseShowCheckoutCustomerInfoFlag">
            <el-select v-model="form.forceCloseShowCheckoutCustomerInfoFlag" :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('forceCloseShowCheckoutCustomerInfoFlag.00')" value="00"></el-option>
              <el-option :label="$t('forceCloseShowCheckoutCustomerInfoFlag.01')" value="01"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="this.country==='PK'">
        <el-col :span="8">
          <el-form-item :label="$t('text.payinRatioControlFlag')"
                        :label-width="formLabelWidth"
                        prop="payinRatioControlFlag">
            <el-select v-model="form.payinRatioControlFlag" :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('payinRatioControlFlag.00')" value="00"></el-option>
              <el-option :label="$t('payinRatioControlFlag.01')" value="01"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item v-if="form.payinRatioControlFlag==='01'"
                        :label="$t('text.payinRatioSetting')"
                        :label-width="formLabelWidth"
                        prop="payinRatioSetting">
            <el-input v-model="form.payinRatioSetting"
                      :placeholder="$t('message.inputPayinRatioSetting')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item :label="$t('text.frozenAmount')"
                    :label-width="formLabelWidth"
                    prop="freezeBalance">
        <el-input v-model="form.freezeBalance"
                  @input="(val) => handleInput(val, 'freezeBalance')"
                  autocomplete="off"
                  :placeholder="$t('message.inputFreezeAmount')"/>
      </el-form-item>

      <el-row>
        <el-col :span="12">
          <el-form-item
              :label="$t('text.withdrawExchangeRate')"
              :label-width="formLabelWidth"
              prop="withdrawalRate"
          >
            <el-input
                v-model="form.withdrawalRate"
                @input="(val) => handleInput(val, 'withdrawalRate')"
                :placeholder="$t('message.inputWithdrawalRate')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
              :label="$t('text.rechargeExchangeRate')"
              :label-width="formLabelWidth"
              prop="rechargeRate"
          >
            <el-input
                v-model="form.rechargeRate"
                @input="(val) => handleInput(val, 'rechargeRate')"
                :placeholder="$t('message.inputRechargeRate')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item
              :label="$t('text.payoutMinAmount')"
              :label-width="formLabelWidth"
              prop="withdrawMinAmount"
          >
            <el-input
                v-model="form.withdrawMinAmount"
                @input="(val) => handleInput(val, 'withdrawMinAmount')"
                :placeholder="$t('message.inputMinTransactionAmount')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
              :label="$t('text.payoutMaxAmount')"
              :label-width="formLabelWidth"
              prop="withdrawMaxAmount"
          >
            <el-input
                v-model="form.withdrawMaxAmount"
                @input="(val) => handleInput(val, 'withdrawMaxAmount')"
                :placeholder="$t('message.inputMaxTransactionAmount')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
              :label="$t('text.payoutNotifyAmount')"
              :label-width="formLabelWidth"
              prop="withdrawTelegramNotifyAmount"
          >
            <el-input
                v-model="form.withdrawTelegramNotifyAmount"
                @input="(val) => handleInput(val, 'withdrawTelegramNotifyAmount')"
                :placeholder="$t('message.inputNotifyTransactionAmount')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" v-for="(value, key) in PaymentType[this.country].PAYMENT">
          <el-form-item
              :label="$t(`text.collection${key}FeeRate`)"
              :label-width="formLabelWidth"
              :prop="`paymentRateConfig.${value}`"
          >
            <el-input
                v-model="form.paymentRateConfig[value]"
                :placeholder="$t('message.inputCollectionFeeRate')"
                @input="handleInput($event, `paymentRateConfig.${value}`)"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8" v-for="(value, key) in PaymentType[this.country].TRANSFER">
          <el-form-item
              :label="$t(`text.disbursement${key}FeeRate`)"
              :label-width="formLabelWidth"
              :prop="`transferRateConfig.${value}`"
          >
            <el-input
                v-model="form.transferRateConfig[value]"
                :placeholder="$t('message.inputCollectionFeeRate')"
                @input="handleInput($event, `transferRateConfig.${value}`)"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item
              :label="$t(`text.merchant.risk.minute`)"
              :label-width="formLabelWidth"
              :prop="`riskConfig.minute`"
          >
            <el-input
                v-model="form.riskConfig.minute"
                :placeholder="$t('message.inputMinute')"
                @input="(val) => handleInput(val, `riskConfig.minute`)"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
              :label="$t(`text.merchant.risk.times`)"
              :label-width="formLabelWidth"
              :prop="`riskConfig.times`"
          >
            <el-input
                v-model="form.riskConfig.times"
                :placeholder="$t('message.inputTimes')"
                @input="(val) => handleInput(val, `riskConfig.times`)"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item
              :label="$t(`text.merchant.risk.dailyMaxAmount`)"
              :label-width="formLabelWidth"
              :prop="`riskConfig.dailyMaxAmount`"
          >
            <el-input
                v-model="form.riskConfig.dailyMaxAmount"
                :placeholder="$t('message.inputAmount')"
                @input="(val) => handleInput(val, `riskConfig.dailyMaxAmount`)"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
              :label="$t(`text.merchant.risk.dailyMaxCount`)"
              :label-width="formLabelWidth"
              :prop="`riskConfig.dailyMaxCount`"
          >
            <el-input
                v-model="form.riskConfig.dailyMaxCount"
                :placeholder="$t('message.inputTimes')"
                @input="(val) => handleInput(val, `riskConfig.dailyMaxCount`)"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item :label="$t('text.rcsIp')" :label-width="formLabelWidth" prop="rcsIp">
        <el-input v-model="form.rcsIp"
                  disabled
                  :placeholder="$t('message.inputRcsIp')"/>
      </el-form-item>

      <el-form-item :label="$t('text.eMail')"
                    :label-width="formLabelWidth"
                    prop="email">
        <el-input v-model="form.email"
                  :disabled="action === 'editMerchant'"
                  :placeholder="$t('message.inputMail')"/>
      </el-form-item>

      <el-form-item :label="$t('text.productDetails')"
                    :label-width="formLabelWidth"
                    prop="productDetails">
        <el-input v-model="form.productDetails"
                  type="textarea"
                  :placeholder="$t('message.inputProductDetails')"/>
      </el-form-item>

      <el-row>
        <el-col :span="8">
          <el-form-item v-if="ROLE_TYPE.isManager()"
                        :label="$t('text.subMerchantName')"
                        :label-width="formLabelWidth"
                        prop="subMerchantName">
            <el-input v-model="form.subMerchantName"
                      autocomplete="off"
                      :placeholder="$t('message.subMerchantName')"/>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item v-if="ROLE_TYPE.isManager()"
                        :label="$t('text.subMerchantWebsiteURL')"
                        :label-width="formLabelWidth"
                        prop="subMerchantWebsiteURL">
            <el-input v-model="form.subMerchantWebsiteURL"
                      autocomplete="off"
                      :placeholder="$t('message.subMerchantWebsiteURL')"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item v-if="action !== 'addMerchant' && ROLE_TYPE.isManager()"
                        :label="$t('text.tgGroupUnbind')"
                        :label-width="formLabelWidth"
                        prop="tgGroupId">
            <el-button
                type="danger"
                @click="confirmUnbind"
                :disabled="form.tgGroupIdCheck === 'false'">
              {{ form.tgGroupIdCheck === 'true' ? $t('text.unbind') : $t('text.unbound') }}
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('text.tgGroupLanguage')"
                        :label-width="formLabelWidth"
                        prop="tgGroupLanguage">
            <el-select v-model="form.tgGroupLanguage"
                       :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('tgLanguage.responseCommand')"
                         value="01"
                         :disabled="form.tgGroupLanguage === '01'"/>
              <el-option :label="$t('tgLanguage.responseCN')"
                         value="02"
                         :disabled="form.tgGroupLanguage === '02'"/>
              <el-option :label="$t('tgLanguage.responseEN')"
                         value="03"
                         :disabled="form.tgGroupLanguage === '03'"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog"> {{ $t('text.cancel') }}</el-button>
      <el-button type="primary" @click="saveMerchant"> {{ $t('text.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {ROLE_TYPE} from "@/utils/Constant";
import {PaymentType, getEmptyConfig} from '@/constants/paymentTypes';

export default {
  name: "SystemEdit",
  computed: {
    PaymentType() {
      return PaymentType
    },
    ROLE_TYPE() {
      return ROLE_TYPE
    }
  },
  props: {
    show: Boolean,
    formData: Object,
    action: String
  },

  created() {
    this.$axios
        .get("/agent/selectAgentForOption", {params: {}})
        .then((res) => {
          this.agentList = res.data;
        });
  },
  data() {
    const generateRules = () => {
      const payment = PaymentType[this.$store.state.isPK ? 'PK' : 'BD'].PAYMENT;
      const transfer = PaymentType[this.$store.state.isPK ? 'PK' : 'BD'].TRANSFER;
      const rules = {
        loginName: [
          {required: true, message: this.$t('message.inputMerchantLoginName'), trigger: "blur"},
          {min: 6, max: 20, message: this.$t('message.loginNameLengthError'), trigger: "blur"}
        ],
        merchantName: [
          {required: true, message: this.$t('message.inputMerchantName'), trigger: "blur"},
          {min: 2, max: 20, message: this.$t('message.merchantNameLengthError'), trigger: "blur"}
        ],
        bdName: [
          {required: true, message: this.$t('message.inputBdName'), trigger: "blur"},
          {min: 1, max: 64, message: this.$t('message.lengthLimitError', {max: '64'}), trigger: "blur"}
        ],
        depositStatus: [
          {required: true, message: this.$t('message.depositStatusRequiredError'), trigger: "blur"}
        ],
        withdrawStatus: [
          {required: true, message: this.$t('message.withdrawStatusRequiredError'), trigger: "blur"}
        ],
        merchantType: [
          {required: true, message: this.$t('message.typeRequiredError'), trigger: "blur"}
        ],
        creditFlag: [
          {required: true, message: this.$t('message.chooseOne'), trigger: "blur"}
        ],
        riskFlag: [
          {required: true, message: this.$t('message.chooseOne'), trigger: "blur"}
        ],
        forceCloseShowCheckoutCustomerInfoFlag: [
          {required: true, message: this.$t('message.chooseOne'), trigger: "blur"}
        ],
        freezeBalance: [
          {required: true, message: this.$t('message.inputFreezeAmount'), trigger: "blur"}
        ],
        withdrawalRate: [
          {required: true, message: this.$t('message.inputWithdrawalRate'), trigger: "blur"}
        ],
        availableCreditQuota: [
          {required: true, pattern: /^\d+(\.\d{0,2})?$/, message: this.$t('message.numericError'), trigger: "blur"}
        ],
        rechargeRate: [
          {required: true, message: this.$t('message.inputRechargeRate'), trigger: "blur"}
        ],
        rcsIp: [
          {required: true, message: this.$t('message.inputRcsIp'), trigger: "blur"},
          {min: 1, max: 255, message: this.$t('message.lengthLimitError', {max: '255'}), trigger: "blur"}
        ],
        email: [
          {required: true, message: this.$t('message.inputMail'), trigger: "blur"},
          {min: 1, max: 255, message: this.$t('message.lengthLimitError', {max: '254'}), trigger: "blur"}
        ],
        productDetails: [
          {required: true, message: this.$t('message.inputProductDetails'), trigger: "blur"},
          {min: 1, max: 1024, message: this.$t('message.lengthLimitError', {max: '1024'}), trigger: "blur"}
        ],
        settlementCycle: [
          {required: true, message: this.$t('message.settlementCycleRequiredError'), trigger: "blur"}
        ]
      };

      Object.keys(payment).forEach((value) => {
        rules[`paymentRateConfig.${payment[value]}`] = [
          {required: true, message: this.$t('message.inputCollectionFeeRate'), trigger: 'blur'},
          {pattern: /^\d+(\.\d{0,2})?$/, message: this.$t('message.numericError'), trigger: 'blur'}
        ];
      });
      Object.keys(transfer).forEach((value) => {
        rules[`transferRateConfig.${transfer[value]}`] = [
          {required: true, message: this.$t('message.inputDisbursementFeeRate'), trigger: 'blur'},
          {pattern: /^\d+(\.\d{0,2})?$/, message: this.$t('message.numericError'), trigger: 'blur'}
        ];
      });

      return rules;
    };

    return {
      dialogShow: this.show,
      country: this.$store.state.isPK ? 'PK' : 'BD',
      form: {
        loginName: "",
        merchantName: "",
        bdName: "",
        depositStatus: "01",
        withdrawStatus: "01",
        prodStatus: "00",
        cashDeposit: 0,
        agentId: "",
        rcsIp: "127.0.0.1",
        email: "test@gmail.com",
        freezeBalance: "0",
        withdrawalRate: "1.5",
        rechargeRate: "0",
        withdrawMinAmount: "1",
        withdrawMaxAmount: "100000",
        withdrawTelegramNotifyAmount: "50000",
        paymentRateConfig: getEmptyConfig(this.$store.state.isPK ? 'PK' : 'BD', 'PAYMENT'),
        transferRateConfig: getEmptyConfig(this.$store.state.isPK ? 'PK' : 'BD', 'TRANSFER'),
        riskConfig: this.getEmptyRiskConfig(),
        productDetails: "",
        notifyV2: "01",
        settlementCycle: "D0",
        merchantType: "01",
        subMerchantName: "",
        subMerchantWebsiteURL: "",
        tgGroupIdCheck: 'false',
        tgGroupLanguage: '01',
        creditFlag: "00",
        creditRate: 0,
        payinRatioControlFlag: "00",
        payinRatioSetting: "1:1",
        riskFlag: "00",
        forceCloseShowCheckoutCustomerInfoFlag: "00",
        availableCreditQuota: '0',
        forceUpdate: false,
      },
      agentList: [],
      formLabelWidth: "150px",
      rules: generateRules(),
    };
  },
  methods: {
    handleInput(val, type) {
      val = val.replace(/[^\d.]/g, ""); // 清除"数字"和"."以外的字符
      val = val.replace(/\.{2,}/g, "."); // 只保留第一个. 清除多余的
      val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      val = val.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); // 只能输入两个小数
      if (val.indexOf(".") < 0 && val !== "" && !type.includes("RateConfig")) {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        val = parseFloat(val);
      }

      if (type.includes('.')) {
        const [obj, key] = type.split('.');
        this.form[obj][key] = val;
      } else {
        this.form[type] = val;
      }
      this.$forceUpdate();
    },
    openDialog() {
      if (this.action === "editMerchant") {
        this.form = Object.assign({}, this.formData);
        this.form.forceUpdate = false;
        this.form.freezeBalance = this.$formatter.FenToYuan(
            null,
            null,
            this.formData.freezeBalance,
            null
        );
        this.form.withdrawMinAmount = this.$formatter.FenToYuan(
            null,
            null,
            this.formData.withdrawMinAmount,
            null
        );
        this.form.withdrawMaxAmount = this.$formatter.FenToYuan(
            null,
            null,
            this.formData.withdrawMaxAmount,
            null
        );
        this.form.withdrawTelegramNotifyAmount = this.$formatter.FenToYuan(
            null,
            null,
            this.formData.withdrawTelegramNotifyAmount,
            null
        );

        // paymentRateConfig
        let paymentConfig = this.formData.paymentRateConfig ? this.formData.paymentRateConfig : '{}';
        paymentConfig = JSON.parse(paymentConfig);
        this.form.paymentRateConfig = {
          ...getEmptyConfig(this.country, 'PAYMENT'),
          ...paymentConfig
        };

        // transferRateConfig
        let transferConfig = this.formData.transferRateConfig ? this.formData.transferRateConfig : '{}';
        transferConfig = JSON.parse(transferConfig);
        this.form.transferRateConfig = {
          ...getEmptyConfig(this.country, 'TRANSFER'),
          ...transferConfig
        };

        // riskConfig
        let riskConfig = this.formData.riskConfig ? this.formData.riskConfig : '{}';
        riskConfig = JSON.parse(riskConfig);
        this.form.riskConfig = {
          ...this.getEmptyRiskConfig(),
          ...riskConfig
        };
      }
    },
    getEmptyRiskConfig(){
      let config = {};
      config.minute = '';
      config.times = '';
      config.dailyMaxAmount = '';
      config.dailyMaxCount = '';
      return config;
    },
    closeDialog() {
      this.$refs["form"].clearValidate();

      // 然后手动设置默认值
      this.form = {
        loginName: "",
        merchantName: "",
        bdName: "",
        depositStatus: "01",
        withdrawStatus: "01",
        merchantType: "01",
        cashDeposit: 0,
        agentId: "",
        prodStatus: "00",
        rcsIp: "127.0.0.1",
        email: "test@gmail.com",
        freezeBalance: "0",
        withdrawalRate: "2",
        rechargeRate: "0",
        withdrawMinAmount: "1",
        withdrawMaxAmount: "100000",
        withdrawTelegramNotifyAmount: "50000",
        paymentRateConfig: getEmptyConfig(this.country, 'PAYMENT'),
        transferRateConfig: getEmptyConfig(this.country, 'TRANSFER'),
        riskConfig: this.getEmptyRiskConfig(),
        productDetails: "",
        notifyV2: "01",
        settlementCycle: "D0",
        subMerchantName: "",
        subMerchantWebsiteURL: "",
        tgGroupIdCheck: 'false',
        creditFlag: "00",
        creditRate: 0,
        payinRatioControlFlag: "00",
        payinRatioSetting: "1:1",
        riskFlag: "00",
        forceCloseShowCheckoutCustomerInfoFlag: "00",
        availableCreditQuota: '0',
        forceUpdate: false,
      };

      this.$emit("update:show", false);
    },
    confirmUnbind() {
      const message = `确定要解除商户 <span style="font-size: 16px; font-weight: bold;">${this.form.merchantName} - ${this.form.appId}</span> 绑定吗？`;

      this.$confirm(`<div>${message}</div>`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.handleUnbind(this.form.appId);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消解绑',
        });
      });
    },
    handleUnbind(appId) {
      const param = {appId: appId};
      console.log(param);
      this.$axios
          .put('/merchant/unbind-tg-group', param)
          .then(res => {
            if (res.code === 200) {
              this.$notify.success({
                title: this.$t('text.prompt').toString(),
                message: res.msg
              });
              return true;
            } else {
              this.$notify.error({
                title: this.$t('text.prompt').toString(),
                message: res.msg
              });
              return false;
            }
          }).catch(() => {
        this.unlockPage();
      });
      this.form = {
        loginName: "",
        merchantName: "",
        bdName: "",
        depositStatus: "01",
        withdrawStatus: "01",
        merchantType: "01",
        cashDeposit: 0,
        agentId: "",
        prodStatus: "00",
        rcsIp: "127.0.0.1",
        email: "test@gmail.com",
        freezeBalance: "0",
        withdrawalRate: "2",
        rechargeRate: "0",
        withdrawMinAmount: "1",
        withdrawMaxAmount: "100000",
        withdrawTelegramNotifyAmount: "50000",
        paymentRateConfig: getEmptyConfig(this.country, 'PAYMENT'),
        transferRateConfig: getEmptyConfig(this.country, 'TRANSFER'),
        riskConfig: this.getEmptyRiskConfig(),
        productDetails: "",
        notifyV2: "01",
        settlementCycle: "D0",
        subMerchantName: "",
        subMerchantWebsiteURL: "",
        tgGroupIdCheck: 'false',
        creditFlag: "00",
        creditRate: 0,
        payinRatioControlFlag: "00",
        payinRatioSetting: "1:1",
        riskFlag: "00",
        forceCloseShowCheckoutCustomerInfoFlag: "00",
        availableCreditQuota: '0',
      };
      this.$refs["form"].resetFields(); //关闭的时候重置表单
      this.$emit("update:show", false);
    },

    saveMerchant() {
      if (this.action === "addMerchant") {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            const paymentConfig = {
              ...getEmptyConfig(this.country, 'PAYMENT'),
              ...this.form.paymentRateConfig
            };
            const transferConfig = {
              ...getEmptyConfig(this.country, 'TRANSFER'),
              ...this.form.transferRateConfig
            };
            const riskConfig = {
              ...this.getEmptyRiskConfig(),
              ...this.form.riskConfig
            };
            this.form.paymentRateConfig = JSON.stringify(paymentConfig);
            this.form.transferRateConfig = JSON.stringify(transferConfig);
            this.form.riskConfig = JSON.stringify(riskConfig);
            this.form.availableCreditQuota = this.form.availableCreditQuota * 100
            this.axios.post("/merchant/addMerchant", this.form).then((res) => {
              if (res.code === 200) {
                this.$notify.success({
                  title: this.$t('text.prompt'),
                  message: res.msg
                });
              }else {
                this.$notify.error({
                  title: this.$t('text.prompt'),
                  message: res.msg
                });
                return false;
              }

              this.$bus.$emit("refresh"); //通知刷新
              this.closeDialog();

              // let filename;
              // var contentDisposition = res.headers["content-disposition"];
              // var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              // var matches = filenameRegex.exec(contentDisposition);
              // if (matches != null && matches[1]) {
              //   filename = matches[1].replace(/['"]/g, "");
              // }
              //
              // let blob = new Blob([res.data], {
              //   type: "text/plain"
              // });
              // // 将blob对象转为一个URL
              // var blobURL = window.URL.createObjectURL(blob);
              // // 创建一个a标签
              // var tempLink = document.createElement("a");
              // // 隐藏a标签
              // tempLink.style.display = "none";
              // // 设置a标签的href属性为blob对象转化的URL
              // tempLink.href = blobURL;
              // // 给a标签添加下载属性
              // tempLink.setAttribute("download", filename);
              // if (typeof tempLink.download === "undefined") {
              //   tempLink.setAttribute("target", "_blank");
              // }
              // // 将a标签添加到body当中
              // document.body.appendChild(tempLink);
              // // 启动下载
              // tempLink.click();
              // // 下载完毕删除a标签
              // document.body.removeChild(tempLink);
              // window.URL.revokeObjectURL(blobURL);
              //
              // this.$message({
              //   title: this.$t('text.prompt'),
              //   message: this.$t('message.addAgentSuccess'),
              //   type: "success"
              // });
            });
          } else {
            return false;
          }
        });
      }

      if (this.action === "editMerchant") {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            const paymentConfig = {
              ...getEmptyConfig(this.country, 'PAYMENT'),
              ...this.form.paymentRateConfig
            }
            const transferConfig = {
              ...getEmptyConfig(this.country, 'TRANSFER'),
              ...this.form.transferRateConfig
            };
            const riskConfig = {
              ...this.getEmptyRiskConfig(),
              ...this.form.riskConfig
            };
            this.form.paymentRateConfig = JSON.stringify(paymentConfig);
            this.form.transferRateConfig = JSON.stringify(transferConfig);
            this.form.riskConfig = JSON.stringify(riskConfig);
            this.form.availableCreditQuota = this.form.availableCreditQuota * 100
            this.form.forceUpdate = false;
            this.axios
                .post("/merchant/updateMerchant", this.form)
                .then((res) => {
                  if (res.code === 200) {
                    this.$notify({
                      title: this.$t('text.prompt'),
                      message: res.msg,
                      type: "success"
                    });

                    this.$bus.$emit("refresh"); //通知刷新

                    this.closeDialog();
                  } else if ((res.msg || '').includes('通道成本')) {
                    this.form.paymentRateConfig = JSON.parse(this.form.paymentRateConfig);
                    this.form.transferRateConfig = JSON.parse(this.form.transferRateConfig);
                    this.form.riskConfig = JSON.parse(this.form.riskConfig);
                    this.form.availableCreditQuota = this.form.availableCreditQuota / 100;
                    const warningMessage = (res.msg || '').replace(/；/g, '<br/>');
                    this.$confirm(
                        `<div style="line-height: 1.6; margin-bottom: 12px;">${warningMessage}</div><div>${this.$t('message.confirmForceOperate')}</div>`,
                        this.$t('text.prompt'),
                        {
                          confirmButtonText: this.$t('text.confirm'),
                          cancelButtonText: this.$t('text.cancel'),
                          type: 'warning',
                          dangerouslyUseHTMLString: true,
                        })
                        .then(() => {
                          const paymentConfigForce = {
                            ...getEmptyConfig(this.country, 'PAYMENT'),
                            ...this.form.paymentRateConfig
                          }
                          const transferConfigForce = {
                            ...getEmptyConfig(this.country, 'TRANSFER'),
                            ...this.form.transferRateConfig
                          };
                          const riskConfigForce = {
                            ...this.getEmptyRiskConfig(),
                            ...this.form.riskConfig
                          };
                          this.form.paymentRateConfig = JSON.stringify(paymentConfigForce);
                          this.form.transferRateConfig = JSON.stringify(transferConfigForce);
                          this.form.riskConfig = JSON.stringify(riskConfigForce);
                          this.form.availableCreditQuota = this.form.availableCreditQuota * 100;
                          this.form.forceUpdate = true;
                          this.axios.post("/merchant/updateMerchant", this.form).then((forceRes) => {
                            if (forceRes.code === 200) {
                              this.$notify({
                                title: this.$t('text.prompt'),
                                message: forceRes.msg,
                                type: "success"
                              });
                              this.$bus.$emit("refresh");
                              this.closeDialog();
                            } else {
                              this.form.paymentRateConfig = JSON.parse(this.form.paymentRateConfig);
                              this.form.transferRateConfig = JSON.parse(this.form.transferRateConfig);
                              this.form.riskConfig = JSON.parse(this.form.riskConfig);
                              this.form.availableCreditQuota = this.form.availableCreditQuota / 100;
                              this.form.forceUpdate = false;
                              this.$notify.error({
                                title: this.$t('text.prompt'),
                                message: forceRes.msg
                              });
                            }
                          });
                        })
                        .catch(() => {});
                  } else {
                    this.form.paymentRateConfig = JSON.parse(this.form.paymentRateConfig);
                    this.form.transferRateConfig = JSON.parse(this.form.transferRateConfig);
                    this.form.riskConfig = JSON.parse(this.form.riskConfig);
                    this.form.availableCreditQuota = this.form.availableCreditQuota / 100;
                    this.$notify.error({
                      title: this.$t('text.prompt'),
                      message: res.msg
                    });
                  }
                });
          } else {
            return false;
          }
        });
      }
    }
  },
  watch: {
    show(newVal) {
      this.dialogShow = newVal;
    }
  }
};
</script>

<style scoped></style>
